import React, {Component} from "react";
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {Typography, GridListTile} from "@material-ui/core/";

import CardGridList from "../../components/CardGridList";
import SimpleMediaCard from "../../components/SimpleMediaCard";
import Sidebar from "../../components/Sidebar";
import "./_channelDashboard.css";

import {ChannelRoutes} from "../../modal/channelRoutes";
import {activateSection} from "./redux_actions";

const ChannelDashboard = class ChannelDashboard extends Component {
  render() {
    let {activeSections} = this.props.app;
    let {params} = this.props.match;
    let {organisers: unitOrganisers} = ChannelRoutes[params.channelId];
    let activeOrganiserId = activeSections[params.channelId]||Object.keys(unitOrganisers)[0];
    let img = new Image();
    img.src = ChannelRoutes[params.channelId].icon;
    img.onload = () => {}
    const SidebarHeader = () => (
      <div className="sidebar-header">
        <Typography
          className="sidebar-header-title"
          variant="headline"
          gutterBottom
          align="center"
          color="secondary">
          {ChannelRoutes[params.channelId].title}
        </Typography>
        <div className="sidebar-header-img"><img alt="channel-icon" src={ChannelRoutes[params.channelId].icon}/></div>
      </div>
    );

    return (
      <div id="channel-dashboard">
        <Sidebar
          headerComponent={SidebarHeader}
          active={activeSections[params.channelId] || Object.keys(unitOrganisers)[0]}
          sidebarList={unitOrganisers}
          onClick={(sectionId) => {
          this
            .props
            .activateSection({route: params.channelId, active: sectionId})
        }}/>
        <div style={{
          flexGrow: 1,
          position: "relative"
        }}>
          <div className="section-header-cntr">
            <div>
              <Typography variant="title" gutterBottom color={"secondary"}>
                {unitOrganisers[activeOrganiserId].title}
              </Typography>
            </div>
            <div>
              <Typography noWrap gutterBottom>
                {unitOrganisers[activeOrganiserId].description}
              </Typography>
            </div>
          </div>
          <div
            style={{
            marginTop: "24vh",
            flexGrow: 1
          }}>
            <CardGridList>
              {populateCards(unitOrganisers[activeOrganiserId].units)}
            </CardGridList>
          </div>
        </div>
      </div>
    )
  }
};

const populateCards = channels => {
  return Object
    .keys(channels)
    .map((k, i) => {
      let el = channels[k];
      return <GridListTile key={i} cols={1} style={{
        height: 'auto'
      }}><SimpleMediaCard key={i} cardData={el} enumerate={i+1}/></GridListTile>
    })
}

ChannelDashboard.propTypes = {
  match: PropTypes.object.isRequired,
  app: PropTypes.object.isRequired,
  activateSection: PropTypes.func
};

const mapStateToProps = state => ({app: state.app});

function matchDispatchToProps(dispatch) {
  return bindActionCreators({
    activateSection
  }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(ChannelDashboard);


// WEBPACK FOOTER //
// ./src/containers/application/ChannelDashboard.js